/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `* {
  box-sizing: border-box;
}

:host {
  font-size: 1rem;
  display: inline-block;
  vertical-align: top;
  margin-top: calc(13rem/14);
}
:host .dropArea {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-content: flex-start;
  align-items: center;
}
:host .dropArea > * {
  pointer-events: none;
}
:host .dropArea .container {
  position: relative;
  width: 100%;
  height: calc(100rem/14);
}
:host .dropArea .container .svg,
:host .dropArea .container .border {
  width: 100%;
  height: calc(100rem/14);
}
:host .dropArea .container .border {
  fill: none;
  stroke-width: 2;
  stroke-dasharray: 12 10;
  stroke: #8E989D;
  stroke: var(--davinci-color-outline, #8E989D);
}
:host .dropArea .container .description {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  font-weight: bold;
  color: #737F85;
  color: var(--davinci-color-text-lighter, #737F85);
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-content: flex-start;
  align-items: center;
}
:host .dropArea .container .description .icon {
  fill: #737F85;
  fill: var(--davinci-color-text-lighter, #737F85);
  flex: 0 0 auto;
  margin: 0 calc(5rem/14);
}
:host .dropArea .container .description .text {
  flex: 0 1 auto;
}
:host .dropArea .container .description .text .labelBrowse {
  color: #007CC1;
  color: var(--davinci-color-primary, #007CC1);
}
:host .selected {
  background-color: #EEEFF0;
  background-color: var(--davinci-color-background-3, #EEEFF0);
}
:host .dropArea:hover {
  cursor: pointer;
}
:host .inputfile {
  position: absolute;
  top: calc(-5000rem/14);
}

:host([disabled]) {
  pointer-events: none;
}
:host([disabled]) .dropArea > .container > .svg > .border {
  stroke: #C5CACC;
  stroke: var(--davinci-color-outline-light, #C5CACC);
}
:host([disabled]) .dropArea > .container > .description {
  color: #B1B8BC;
  color: var(--davinci-color-text-disabled, #B1B8BC);
}
:host([disabled]) .dropArea > .container > .description .icon {
  fill: #B1B8BC;
  fill: var(--davinci-color-text-disabled, #B1B8BC);
}
:host([disabled]) .dropArea > .container > .description .labelBrowse {
  color: #B1B8BC;
  color: var(--davinci-color-text-disabled, #B1B8BC);
}

:host([hidden]) {
  display: none;
}`;
export { style };
